<template>

    <div class="pin-top">

        <!-- Top navbar -->
        <navbar-header
            :classList="['bg-danger', 'text-light']"
            :title="'Marketplace'"
            :right="'close-mpl'">
        </navbar-header>

        <!-- Prompt Layout -->
        <prompt-div>

            <!-- Layout body -->
            <template v-slot:body>
                <img class="py-9" alt="" src="/images/illustration-maintenance.svg">
                <div>
                    <h2 class="font-xl font-weight-bold">Hold tight! We're working on some improvements</h2>
                    <h4 class="font-md mt-5">Dont worry, we'll be back online soon.<br/>Please come visit us again later.</h4>
                    <button class="btn btn-md btn-inverted text-primary px-7 mt-6" @click="goBack()">
                        Ok, I understand
                    </button>
                </div>
            </template>

        </prompt-div>

    </div>

</template>

<script>
    export default {
        methods: {
            goBack() {
                let exitLoc = this.$root.getExitLocation()

                // if mobile
                window.location.replace(exitLoc)
            }
        }
    }
</script>
